export const ultimasNoticias = [
     
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_125.png",
        "url" : "https://www.facebook.com/share/p/1C1BF52ZHp/",
        "titulo" : 'Reunion de Gabinete',
        "fecha" : "06-03-2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/UN_126.png",
        "url" : "https://www.facebook.com/share/p/1FifWVWK53/",
        "titulo" : 'Entrega de apoyos y certificados de secundaria',
        "fecha" : "05/03/2026"
    },
    
]